jQuery(function ($) {
  var canBeLoaded = true; // this param allows to initiate the AJAX call only if necessary



  $(".js-load-more").bind('click', function (event) {
    var _this = $(this);

    const term = _this.attr('data-taxonomy');
    const term_value = _this.attr('data-taxvalue');
    
    if(term) {
      window.terms = [{
        name: term,
        value: term_value
      }]
    }

    var data = {
      action: "loadmore",
      post_type: _this.attr('data-posts'),
      partial: _this.attr('data-partial'),
      items: _this.attr('data-items'),
      post_not_in: _this.attr('data-exclude'),
      'start-page': _this.attr('data-startpage'),
      page: _this.attr('data-page'),
      year: _this.attr('data-year'),
      terms: JSON.stringify(window.terms),
      fields: JSON.stringify(window.fields),
      order_by: _this.attr('data-order'),
    };


    var grid = _this.parent().siblings('.grid-items') // Grid where add new items
    var total_items = parseInt(_this.attr('data-tot')) // Total items in the query

    if (canBeLoaded == true) {
      $.ajax({
        type: 'POST',
        url: loadmore_params.ajaxurl,
        data: data,
        beforeSend: function (xhr) {
          // you can also add your own preloader here
          // you see, the AJAX call is in process, we shouldn't run it again until complete
          _this.attr('disabled', true);
          canBeLoaded = false;
          grid.append('<div class="loading-content text-center col-12 section-padding"><div class="spinner-grow" role="status"></div></div>')
        },
        success: function (results) {
          if (results) {
            results = JSON.parse(results)
            if (results && results.total > 0) {
            $('.loading-content').remove()
            grid.append(results.html); // where to insert posts
            canBeLoaded = true; // the ajax is completed, now we can run it again
            var next_page = parseInt(_this.attr('data-page')) + 1
            _this.attr('data-page', next_page); // !!!!! increment
            }
          }
        },
        error: function (error) {
          console.log(error);
        },
        complete: function () {
          _this.attr('disabled', false);
          if (grid.children().length === total_items) {
            _this.hide(); // Hide button if there is no more elements
            _this.parent().addClass('mt-n3') // Add negative margin to parent button
          }
        }
      });
    }
  });
});